import * as bootstrap from "bootstrap";

export function initTooltips(selector = '[data-bs-toggle="tooltip"]')
{
    const tooltipTriggerList = document.querySelectorAll(selector);
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl, {
        trigger: "hover focus click"
    }));
}